import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { pink } from "../variables"
import { useCursorChange } from "../hooks"

const SiteBranding = ({ toggleNav, isNavOpen }) => {
  const [bind] = useCursorChange({ selected: "selected" })

  return (
    <Link to="/">
      <h1 className="visually-hidden">Sae Design Group</h1>
      <BrandingContainer {...bind} onClick={isNavOpen ? toggleNav : undefined}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="sdg-face"
          viewBox="0 0 41.56 41.56"
        >
          <g id="Layer_2" data-name="Layer 2">
            <path
              className="cls-1"
              d="M14.16,24.05c2.48,0,3.54-1.39,3.54-4.67,0-2.52-.69-3.65-2.75-4.47L14,14.55c-1-.39-1.46-.86-1.46-2.57,0-1.89.64-2.28,1.6-2.28s1.57.27,1.64,2.24l.21.44.46.08.63-.11h.05a.56.56,0,0,0,.4-.59c-.07-2.54-1.22-3.82-3.41-3.82S10.75,9.31,10.75,12c0,2.49.67,3.55,2.77,4.37l.91.35c1,.38,1.43.89,1.43,2.77,0,2.56-.76,2.77-1.68,2.77s-1.69-.43-1.84-2.57a.48.48,0,0,0-.2-.43.49.49,0,0,0-.47-.09l-.65.13a.53.53,0,0,0-.45.61C10.69,22.67,11.9,24.05,14.16,24.05Z"
            />
            <path
              className="cls-1"
              d="M30.53,27.05H11a.56.56,0,0,0-.57.57v2.67a3.34,3.34,0,0,0,2.45,3.57c.84.27,1.77.37,5.34.37.09,0,9.27,0,10.39-.37a3.34,3.34,0,0,0,2.45-3.57V27.62A.55.55,0,0,0,30.53,27.05Zm-1.1,3.1a1.77,1.77,0,0,1-1.28,2c-.54.17-5.66.29-9.93.29-3.34,0-4.18-.09-4.81-.29a1.77,1.77,0,0,1-1.28-2V28.87h17.3Z"
            />
            <path
              className="cls-1"
              d="M21.06,0h-.29a20.78,20.78,0,0,0-.28,41.56h.29A20.78,20.78,0,0,0,21.06,0Zm-.28,39.61h-.26a18.84,18.84,0,0,1,.25-37.67H21a18.84,18.84,0,0,1-.26,37.67Z"
            />
            <path
              className="cls-1"
              d="M30.65,15.33H27.81a.55.55,0,0,0-.57.57v.62a.56.56,0,0,0,.57.58h1.58c0,3.26-.08,3.65-.21,4.07a1.74,1.74,0,0,1-3.22,0c-.14-.46-.21-.87-.21-5.19s.07-4.73.2-5.18a1.51,1.51,0,0,1,1.6-1.09c1.05,0,1.63.59,1.82,1.85l.24.39.45.06.64-.13,0,0a.57.57,0,0,0,.39-.67,3.38,3.38,0,0,0-3.58-3.27,3.22,3.22,0,0,0-3.37,2.3c-.25.73-.31,1.39-.31,5.76s.06,5,.3,5.76a3.24,3.24,0,0,0,3.38,2.3,3.24,3.24,0,0,0,3.37-2.3c.24-.73.3-1.34.3-5.25v-.6A.56.56,0,0,0,30.65,15.33Z"
            />
          </g>
        </svg>
        <svg
          id="sdg-heading"
          data-name="Group 2"
          xmlns="http://www.w3.org/2000/svg"
          width="150.667"
          height="17.443"
          viewBox="0 0 150.667 17.443"
        >
          <path
            id="Path_2"
            data-name="Path 2"
            d="M83.737,45.925c-2.748,0-4.169-1.476-4.247-4.45,0-.148.047-.25.2-.273l2.1-.351a.219.219,0,0,1,.273.226c.078,1.8.6,2.5,1.749,2.5,1.077,0,1.6-.578,1.6-2.42,0-1.819-.351-2.42-1.671-2.951l-1.023-.4c-2.35-.921-3.045-2.147-3.045-4.794,0-2.92,1.327-4.521,4.123-4.521s4.021,1.5,4.169,4.146a.268.268,0,0,1-.226.273l-2,.3c-.148.023-.273-.047-.273-.2-.047-1.4-.5-2.171-1.6-2.171-1.046,0-1.546.648-1.546,2.046,0,1.577.3,2.046,1.647,2.577l1.023.4c2.225.874,3.1,2.077,3.1,4.974C88.086,44.176,86.962,45.925,83.737,45.925Z"
            transform="translate(-79.49 -28.482)"
            fill="#ea3056"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M96.769,29.02c.047-.148.125-.25.273-.25h2.1a.272.272,0,0,1,.273.25l3.6,16.49a.192.192,0,0,1-.2.25h-2.124a.257.257,0,0,1-.273-.25l-.671-3.42H96.37L95.7,45.51a.257.257,0,0,1-.273.25H93.3a.2.2,0,0,1-.2-.25Zm2.545,10.822-1.2-6.317h-.078l-1.249,6.317Z"
            transform="translate(-82.472 -28.544)"
            fill="#ea3056"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M109.16,29.02a.238.238,0,0,1,.25-.25h6.972a.238.238,0,0,1,.25.25v1.921a.238.238,0,0,1-.25.25h-4.4a.129.129,0,0,0-.148.148v4.474a.129.129,0,0,0,.148.148h3.795a.238.238,0,0,1,.25.25v1.921a.238.238,0,0,1-.25.25h-3.795a.129.129,0,0,0-.148.148v4.646a.129.129,0,0,0,.148.148h4.4a.238.238,0,0,1,.25.25v1.921a.238.238,0,0,1-.25.25H109.41a.238.238,0,0,1-.25-.25Z"
            transform="translate(-85.994 -28.544)"
            fill="#ea3056"
          />
          <path
            id="Path_5"
            data-name="Path 5"
            d="M122.63,29.02a.238.238,0,0,1,.25-.25h3.92c2.225,0,3.521.9,4.123,2.725.3.921.422,2.077.422,5.77s-.125,4.849-.422,5.77c-.6,1.827-1.9,2.725-4.123,2.725h-3.92a.238.238,0,0,1-.25-.25Zm2.819,14.32h1.077a1.67,1.67,0,0,0,1.8-1.226c.2-.625.3-1.452.3-4.849s-.1-4.224-.3-4.849a1.675,1.675,0,0,0-1.8-1.226h-1.077a.129.129,0,0,0-.148.148V43.183A.138.138,0,0,0,125.449,43.339Z"
            transform="translate(-88.947 -28.544)"
            fill="#ea3056"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M138.08,29.02a.238.238,0,0,1,.25-.25H145.3a.238.238,0,0,1,.25.25v1.921a.238.238,0,0,1-.25.25h-4.4a.129.129,0,0,0-.148.148v4.474a.129.129,0,0,0,.148.148H144.7a.238.238,0,0,1,.25.25v1.921a.238.238,0,0,1-.25.25h-3.795a.129.129,0,0,0-.148.148v4.646a.129.129,0,0,0,.148.148h4.4a.238.238,0,0,1,.25.25v1.921a.238.238,0,0,1-.25.25H138.33a.238.238,0,0,1-.25-.25V29.02Z"
            transform="translate(-92.334 -28.544)"
            fill="#ea3056"
          />
          <path
            id="Path_7"
            data-name="Path 7"
            d="M155.1,45.925c-2.748,0-4.169-1.476-4.247-4.45,0-.148.047-.25.2-.273l2.1-.351a.219.219,0,0,1,.273.226c.078,1.8.6,2.5,1.749,2.5,1.077,0,1.6-.578,1.6-2.42,0-1.819-.351-2.42-1.671-2.951l-1.023-.4c-2.35-.921-3.045-2.147-3.045-4.794,0-2.92,1.327-4.521,4.123-4.521s4.021,1.5,4.169,4.146a.268.268,0,0,1-.226.273l-2,.3c-.148.023-.273-.047-.273-.2-.047-1.4-.5-2.171-1.6-2.171-1.046,0-1.546.648-1.546,2.046,0,1.577.3,2.046,1.647,2.577l1.023.4c2.225.874,3.1,2.077,3.1,4.974C159.446,44.176,158.322,45.925,155.1,45.925Z"
            transform="translate(-95.133 -28.482)"
            fill="#ea3056"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M165.76,29.02a.238.238,0,0,1,.25-.25h2.171a.238.238,0,0,1,.25.25V45.51a.238.238,0,0,1-.25.25H166.01a.238.238,0,0,1-.25-.25Z"
            transform="translate(-98.402 -28.544)"
            fill="#ea3056"
          />
          <path
            id="Path_9"
            data-name="Path 9"
            d="M173.48,37.2c0-4.724.078-5.325.328-6.074a3.846,3.846,0,0,1,4.021-2.647c2.452,0,3.951,1.3,4.224,3.974a.259.259,0,0,1-.2.3l-2.022.351a.218.218,0,0,1-.273-.2c-.125-1.327-.7-2-1.7-2a1.458,1.458,0,0,0-1.476.953c-.148.476-.172.671-.172,5.348s.023,4.872.172,5.348a1.674,1.674,0,0,0,3.022,0c.125-.422.172-.671.172-3.826a.129.129,0,0,0-.148-.148h-1.327a.238.238,0,0,1-.25-.25v-1.85a.238.238,0,0,1,.25-.25h3.795a.238.238,0,0,1,.25.25v.75c0,4.7-.078,5.294-.328,6.043a4.36,4.36,0,0,1-8.019,0C173.55,42.526,173.48,41.925,173.48,37.2Z"
            transform="translate(-100.094 -28.48)"
            fill="#ea3056"
          />
          <path
            id="Path_10"
            data-name="Path 10"
            d="M188.77,29.02a.238.238,0,0,1,.25-.25h2.647a.316.316,0,0,1,.351.25l3.147,11.743h.125V29.02a.238.238,0,0,1,.25-.25h1.85a.238.238,0,0,1,.25.25V45.51a.238.238,0,0,1-.25.25h-2.475a.316.316,0,0,1-.351-.25l-3.295-11.743h-.148V45.51a.238.238,0,0,1-.25.25h-1.85a.238.238,0,0,1-.25-.25Z"
            transform="translate(-103.446 -28.544)"
            fill="#ea3056"
          />
          <path
            id="Path_11"
            data-name="Path 11"
            d="M204.93,37.208c0-4.974.078-5.622.328-6.371a3.273,3.273,0,0,1,3.42-2.327,3.429,3.429,0,0,1,3.646,3.35c.023.172-.023.273-.172.328l-.726.148c-.172.047-.273-.023-.3-.172-.226-1.5-.953-2.42-2.452-2.42a2.079,2.079,0,0,0-2.171,1.5c-.172.578-.25,1.1-.25,5.973s.078,5.4.25,5.973a2.367,2.367,0,0,0,4.4,0c.172-.578.25-1.1.25-4.974a.129.129,0,0,0-.148-.148H208.99a.238.238,0,0,1-.25-.25v-.7a.238.238,0,0,1,.25-.25h3.2a.238.238,0,0,1,.25.25v.671c0,4.4-.078,5.044-.328,5.793a3.677,3.677,0,0,1-6.84,0C205.008,42.83,204.93,42.181,204.93,37.208Z"
            transform="translate(-106.989 -28.487)"
            fill="#ea3056"
          />
          <path
            id="Path_12"
            data-name="Path 12"
            d="M225.867,45.76a.247.247,0,0,1-.273-.172l-2.2-7.5a7.311,7.311,0,0,1-1.046.078h-1.171a.129.129,0,0,0-.148.148V45.51a.238.238,0,0,1-.25.25h-.8a.238.238,0,0,1-.25-.25V29.02a.238.238,0,0,1,.25-.25h2.42c2.975,0,4.326,1.249,4.326,4.7,0,2.374-.75,3.7-2.1,4.294l2.3,7.745c.047.148,0,.25-.125.25Zm-.453-12.289c0-2.623-.851-3.474-2.92-3.474h-1.327a.129.129,0,0,0-.148.148v6.668a.129.129,0,0,0,.148.148h1.327C224.516,36.968,225.414,36.2,225.414,33.47Z"
            transform="translate(-110.233 -28.544)"
            fill="#ea3056"
          />
          <path
            id="Path_13"
            data-name="Path 13"
            d="M233.9,43.579c-.25-.75-.328-1.4-.328-6.371s.078-5.622.328-6.371a3.677,3.677,0,0,1,6.84,0c.25.75.328,1.4.328,6.371s-.078,5.622-.328,6.371a3.677,3.677,0,0,1-6.84,0Zm5.6-.4c.172-.578.273-1.1.273-5.973s-.1-5.4-.273-5.973a2.321,2.321,0,0,0-4.341,0c-.172.578-.25,1.1-.25,5.973s.078,5.4.25,5.973a2.321,2.321,0,0,0,4.341,0Z"
            transform="translate(-113.267 -28.487)"
            fill="#ea3056"
          />
          <path
            id="Path_14"
            data-name="Path 14"
            d="M248.42,41.762V29.02a.238.238,0,0,1,.25-.25h.8a.238.238,0,0,1,.25.25V41.864c0,1.975.953,2.873,2.374,2.873s2.4-.9,2.4-2.873V29.02a.238.238,0,0,1,.25-.25h.773a.238.238,0,0,1,.25.25V41.762c0,2.826-1.476,4.2-3.67,4.2S248.42,44.589,248.42,41.762Z"
            transform="translate(-116.523 -28.544)"
            fill="#ea3056"
          />
          <path
            id="Path_15"
            data-name="Path 15"
            d="M263.68,45.76a.238.238,0,0,1-.25-.25V29.02a.238.238,0,0,1,.25-.25h2.452c2.975,0,4.349,1.374,4.349,4.919,0,3.521-1.4,4.95-4.349,4.95h-1.249a.129.129,0,0,0-.148.148V45.51a.238.238,0,0,1-.25.25Zm5.5-12.063c0-2.7-.828-3.7-3.045-3.7h-1.249a.129.129,0,0,0-.148.148v7.121a.129.129,0,0,0,.148.148h1.249C268.349,37.413,269.177,36.414,269.177,33.7Z"
            transform="translate(-119.813 -28.544)"
            fill="#ea3056"
          />
        </svg>
      </BrandingContainer>
    </Link>
  )
}

export default SiteBranding

const BrandingContainer = styled.div`
  display: flex;
  align-items: center;
  width: 220px;
  position: relative;
  z-index: 9999;

  svg {
    width: 100%;
    fill: ${pink};
  }

  #sdg-face {
    transition: all 0.2s ease-out;
    transform-origin: center;
    width: 115px;
    margin-right: 5px;

    .cls-1 {
      fill: #e24263;
    }
  }

  #sdg-heading {
    display: block;
    width: 200%;
  }

  &:hover {
    #sdg-face {
      transform: rotate(360deg);
    }
  }
`
